import React, { Component, useState, useEffect } from 'react';

import Hero from './components/Hero'
import Carousel from './components/Carousel';
import HeroProjectManager from './components/HeroProjectManager';
import HeroProjectImage from './components/HeroProjectImage';
import HeroProjectText from './components/HeroProjectText';
import Footer from './components/Footer';
import Portfolio from './components/Portfolio';
import Project from './components/Project';
import About from './components/About';
import CV from './components/CV';
import Contact from './components/Contact';
import ThumbnailCarousel from './components/ThumbnailCarousel';
import Button from './components/Button';
import { base_url, thumbs1, thumbs2, thumbs3 } from './components/Constants.js';

import Futures from './components/Futures';

import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';

import logo from './logo.svg';
import './App.css';
import './components/Hero.css'

function App() {

  return (
    <div className="App" suppressHydrationWarning={true}>

      <ScrollToTop />
      <Hero />

      <Routes>
        <Route path="/home" element={<Home />} exact />
        <Route path="/cv" element={<CV />} />
        <Route path="/futures" element={<Futures />} />



        <Route path="/work" element={<Work />} />


        <Route path="/project" element={<Project />} />
        <Route path="/project/:projectPath" element={<Project />} />
        <Route path="/about" element={<Jeff />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/" element={<Navigate replace to="/home" />} />

      </Routes>


      <Footer />


    </div>


  );
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};



function Home() {

  const textstyle = {
    color: "black",
    backgroundColor: "white",
    fontSize: "4em",
    fontStyle: "italic",
    marginTop: "60px"

  };





  return (



    <div>

      <div className="text-container">
        <h2 className="large-text">HI, I'M <br></br>JEFFREY SERIO!</h2>

        <div className="description-container">
          <p className="small-text">I am a creative, analytical, and award winning digital product designer crafting exceptional user experiences across platforms, products, and services. With an insatiable curiosity to understand people and a strong foundation in design and technology, I offer a distinctive combination of empathy, creativity, and technical expertise. Simplifying complexity and clarifying ambiguity by making innovative solutions tangible to captivate and capture value.</p>
        </div>
      </div>
      <HeroProjectManager />


      <div className="project-container" style={{ backgroundColor: 'white', marginTop: '8em' }}>
        <div className='app-seperator-left'>


          <a href={base_url + "/futures"} style={{ textDecoration: 'none' }}>
            <HeroProjectText style={{ backgroundColor: 'white' }}
              key={'1'}
              subject={'Publication'}
              title={'Design & Futures'}
              description={'A comprehensive book presenting a set of methods integrating design and foresight. The book offers a step-by-step guide drawing from real-life work. Empowering readers to uncover emerging user needs, technological trends, synthesize insights, envision future worlds, and build products manifesting desired futures.'}
              backgroundcolor={'white'}
              fontstyle={textstyle}

            />
          </a>
          <div className="button-container" style={{ paddingBottom: '3rem' }}>
            <Button to="/futures" text="Transform Through Design" />
          </div>
        </div>
        <HeroProjectImage
          key={'1'}
          image={base_url + '/images/signals_together.png'}
        />
      </div>

      <div className="project-container" style={{ backgroundColor: 'white', marginTop: '8em' }}>
        <div className='app-extra-seperator'>
        </div>

        <div className='app-seperator-left'>
          <a href={"https://link.springer.com/chapter/10.1007/978-3-031-35989-7_16"} style={{ textDecoration: 'none' }}>
            <HeroProjectText style={{ backgroundColor: 'white' }}
              key={'1'}
              subject={'Event'}
              title={'HCI Int 2023'}
              description={'I am presenting a the 25th International Conference On Human-Computer Interaction at Bella Center, Copenhagen, DenmarK 23-28 July 2023 on Design, Futures, and User Exeperience. Come and see me talk!'}
              backgroundcolor={'white'}
              fontstyle={textstyle}
            />
          </a>
          <div className="button-container">
            <Button to="/https://link.springer.com/chapter/10.1007/978-3-031-35989-7_16" text="Read The Paper" />
          </div>
        </div>

      </div>
      <div>



        <div className="project-container" style={{ backgroundColor: 'white', marginTop: '8em', marginLeft: '0%', flexDirection: 'column' }}>


          <div style={{ width: '100%' }}>

            <Link to='/work' style={{ textDecoration: 'none' }}>
              <div className='home-portfolio-container'>
                <h2 className='home-portfolio-title underline-animation'>Portfolio</h2>
              </div>
              <ThumbnailCarousel images={thumbs1} direction="left" />
              <ThumbnailCarousel images={thumbs2} direction="right" />
              <ThumbnailCarousel images={thumbs3} direction="left" />
            </Link>
          </div>
          <div style={{ paddingTop: '3rem', display: 'flex', justifyContent: 'center' }}>
            <Button to="/work" text="Making What Matters" />
          </div>


        </div>





      </div>



    </div >
  );
}

function Work() {
  return <Portfolio />
}

function Jeff() {
  return <About />
}

export default App;
